module.exports = __webpack_public_path__ + "static/media/1 knee ex.fce4afda.png";